"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITitleEscrow__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "BeneficiaryTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "HolderTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "prevNominee",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "nominee",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "Nomination",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "RejectTransferBeneficiary",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "RejectTransferHolder",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "RejectTransferOwners",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "caller",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "ReturnToIssuer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "Shred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    indexed: true,
    internalType: "bool",
    name: "isMinting",
    type: "bool"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "TokenReceived",
  type: "event"
}, {
  inputs: [],
  name: "active",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "beneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "holder",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "isHoldingToken",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "nominee",
    type: "address"
  }, {
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "nominate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "nominee",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "operator",
    type: "address"
  }, {
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "prevBeneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "prevHolder",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "registry",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "rejectTransferBeneficiary",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "rejectTransferHolder",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "rejectTransferOwners",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "returnToIssuer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "shred",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "tokenId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "nominee",
    type: "address"
  }, {
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "transferBeneficiary",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newHolder",
    type: "address"
  }, {
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "transferHolder",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "nominee",
    type: "address"
  }, {
    internalType: "address",
    name: "newHolder",
    type: "address"
  }, {
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "transferOwners",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
class ITitleEscrow__factory {
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.ITitleEscrow__factory = ITitleEscrow__factory;
_defineProperty(ITitleEscrow__factory, "abi", _abi);